
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftRight25 as ObiThreewayAcuatorGenericInleftRight25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-right-25.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftRight25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-right-25',
   elementClass: ObiThreewayAcuatorGenericInleftRight25Element,
   events: {
     
   }
  });
 
 